import React, { Component,Fragment } from 'react';
import { Highlighter, AsyncTypeahead } from 'react-bootstrap-typeahead';
import { connect } from 'react-redux';
import {
	BRANCH_ACCESS
} from '../../../constants/general';
import { fetchProviders } from '../../../store/actions/providerActions';


class SearchProvider extends Component {

	constructor(props) {
		super(props);
	    this.state = {
			isLoading:false,
			openSearcher:true,
			selected:"",
			providers: [],
      placeholder:'Buscar rider'
		}
		// this.props.fetchProviders()
	}

	componentDidUpdate(prevProps){
		let newList = [];
		let { providers, userHigherAccess } = this.props;
		if ((prevProps.providers  && prevProps.providers.data && prevProps.providers.data.length) !== (providers.data && providers.data.length)) {

			newList = providers.data.map(b => { return { access_id: b.id, related_access: b } })

			newList = newList.concat({access_id:-1,related_access: {id:-1,name:this.state.placeholder}})
			this.setState({ providers: newList })
		}
	}

	SearchAction(query){
		let { userHigherAccess } = this.props;
		if(userHigherAccess > BRANCH_ACCESS){
			this.props.fetchProviders(1,`name=ilike ${query}`)
		}
	}

	render () {
		return (
            <Fragment>
                <AsyncTypeahead
                    ref={(ref) => (this._typeahead = ref)}
                    labelKey="name"
                    options={this.state.providers.map(
                        ($0) => $0.related_access
                    )}
                    onChange={this.props.change}
                    onSearch={(query) => this.SearchAction(query)}
                    isLoading={this.state.isLoading}
                    value={this.state.selected}
                    placeholder={this.state.placeholder}
                    renderMenuItemChildren={(option, props, index) => (
                        <div
                            className="normaltext-autocomplete"
                            style={{ display: `flex`, gap: `10px` }}
                        >
                            <img
                                className="avatar_small"
                                src={option && option.avatar_url}
                                ref={`avatar_url`}
                                onError={() =>
                                    (this.refs[`avatar_url`].src =
                                        "https://dondemand.sfo2.cdn.digitaloceanspaces.com/avatars/avatar-comprador.png")
                                }
                                alt={option.name}
                            />
                            <div style={{ width: `calc(100% - 40px)` }}>
                                {option.name}
                                <br />
                                <small>{option.email}</small>
                            </div>
                        </div>
                    )}
                />
            </Fragment>
        );
	}
}


const mapStateToProps = (state) => {
	return {
		admin_type:state.session && state.session.admin_type && state.session.admin_type.name,
		company:state.company,
		userHigherAccess: state.userHigherAccess,
		errors: state.errors,
		json_lang: state.json_lang,
		providers:state.providers
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		fetchProviders: (page,query) => dispatch(fetchProviders(page,query)),
	}
}

export default connect(mapStateToProps , mapDispatchToProps)(SearchProvider);



// WEBPACK FOOTER //
// ./src/views/Plugins/SpecialForm/SearchProvider.js